import { db } from '../database/firebase';
import { collection, getDocs, query, orderBy, limit } from 'firebase/firestore';
import { apiGet, useApiData } from './apiClient';

const sanitizeSearchInput = (q) =>
  String(q ?? '')
    .replace(/[\u00a0\u2000-\u200b\u200c\u200d\ufeff]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

const foldTrSearch = (value) => {
  let s = sanitizeSearchInput(value);
  s = s
    .replace(/İ/g, 'i')
    .replace(/I/g, 'i')
    .replace(/ı/g, 'i')
    .replace(/Ğ/g, 'g')
    .replace(/ğ/g, 'g')
    .replace(/Ü/g, 'u')
    .replace(/ü/g, 'u')
    .replace(/Ş/g, 's')
    .replace(/ş/g, 's')
    .replace(/Ö/g, 'o')
    .replace(/ö/g, 'o')
    .replace(/Ç/g, 'c')
    .replace(/ç/g, 'c');
  return s
    .toLocaleLowerCase('tr-TR')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9@+.\-\s]/gi, '')
    .replace(/\s+/g, ' ')
    .trim();
};

const matchesSearch = (user, search) => {
  const raw = sanitizeSearchInput(search);
  if (!raw) return true;
  const needle = foldTrSearch(raw);
  const fullName = foldTrSearch(`${user.name || ''} ${user.surname || ''}`);
  const needleDigits = raw.replace(/\D/g, '');
  const mobileDigits = String(user.mobile || '').replace(/\D/g, '');
  const phoneHit =
    needleDigits.length >= 3 &&
    mobileDigits.includes(needleDigits.slice(-Math.min(needleDigits.length, 10)));

  return (
    foldTrSearch(user.email).includes(needle) ||
    foldTrSearch(user.name).includes(needle) ||
    foldTrSearch(user.surname).includes(needle) ||
    fullName.includes(needle) ||
    String(user.mobile || '').includes(raw) ||
    phoneHit ||
    String(user.id || '').includes(raw)
  );
};

const looksLikeEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

/**
 * @returns {Promise<{ data: Array, total: number }>}
 */
export const getUsers = async ({ search, emailFilter, phoneFilter, last = 100 } = {}) => {
  const searchText = sanitizeSearchInput(search || emailFilter || phoneFilter || '');

  if (useApiData) {
    const qs = new URLSearchParams();
    qs.set('page', '1');
    if (searchText) {
      qs.set('q', searchText);
      if (looksLikeEmail(searchText)) {
        qs.set('email', searchText.toLowerCase());
      }
      // Sunucu taraflı arama — tüm kullanıcılar (sayfa içi değil)
      qs.set('perPage', String(Math.min(Math.max(last, 200), 500)));
    } else {
      qs.set('perPage', String(last));
    }
    const res = await apiGet(`users?${qs.toString()}`);
    return {
      data: res?.data ?? [],
      total: typeof res?.total === 'number' ? res.total : (res?.data?.length ?? 0),
    };
  }

  const collectionRef = collection(db, 'users');
  const q = query(collectionRef, orderBy('createDateTime', 'desc'), limit(last));
  const snap = await getDocs(q);
  const rows = [];
  snap?.forEach((docRef) => rows.push({ id: docRef.id, ...docRef.data() }));

  if (!searchText) return { data: rows, total: rows.length };
  const filtered = rows.filter((user) => matchesSearch(user, searchText));
  return { data: filtered, total: filtered.length };
};

export default { getUsers };
